<template>
	<el-dialog
		:modelValue="open"
		@update:modelValue="$emit('update:open', $event)"
		:title="'Nicht zuständig'"
		@close="handleClose"
		:before-close="(done) => dialogBeforeClose(done, waiting)"
	>
		<TheForm
			:model="request"
			:rules="rules"
			:waiting="waiting"
			:waitingMsg="texts.formErrors.waiting"
			:showErr="showErr"
			:errMsg="errMsg"
			ref="formRef"
			:id="id"
		>
			<el-form-item label="Freitexteingabe" prop="reason">
				<el-input type="textarea" :autosize="{ minRows: 10 }" v-model="request.reason" />
			</el-form-item>
			<el-form-item label="Zuständige Stelle (optional und nur für die Beschwerdeführer:in sichtbar)" prop="relevantAuthority">
				<el-input type="textarea" :autosize="{ minRows: 10 }" v-model="request.relevantAuthority" />
			</el-form-item>
		</TheForm>

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="save" :disabled="waiting" :loading="waiting">Senden</TheButton>
				<TheButton type="default" @buttonclick="handleClose">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

import TheForm from '../TheForm.vue';
import TheButton from '../TheButton.vue';
import { ComplaintNotResponsibleRequest } from '../../types/types';
import { texts, translateToGerman } from '../../utils/texts';
import type { FormInstance } from 'element-plus';
import { complaintNotResponsible } from '@/requests/complaints';
import { validateForm, resetForm, dialogBeforeClose } from '@/utils/functions';

export default defineComponent({
	name: 'DialogNotResponsible',
	data() {
		return {
			request: {
				reason: '',
				relevantAuthority: '',
			},
			rules: {
				reason: [
					{ required: true, message: texts.formErrors.reqMissing, trigger: 'blur' },
					{ min: 3, message: texts.formErrors.minChars, trigger: 'blur' },
				],
			},
			waiting: false,
			id: 'notResponsibleForm',
			showErr: false,
			errMsg: texts.complaints.editFailed,
		};
	},
	components: {
		TheForm,
		TheButton,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		complaintId: {
			type: String,
			required: true,
		},
	},
	computed: {
		texts() {
			return texts;
		},
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	emits: ['reload', 'update:open'],
	methods: {
		async save() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.waiting = true;

			const requestNotResponsible = {
				complaintId: String(this.complaintId),
				notResponsibleReason: this.request.reason,
				notResponsibleRelevantAuthority: this.request.relevantAuthority,
			} as ComplaintNotResponsibleRequest;

			const result = await complaintNotResponsible(requestNotResponsible);
			if (result.success) {
				this.handleClose(true);
			} else {
				const msg = translateToGerman(result.error);
				if (msg) {
					this.errMsg = msg;
				}

				this.showErr = true;
			}

			this.waiting = false;
		},
		handleClose(reload: Boolean) {
			resetForm(this.formRef, this.id);

			this.showErr = false;

			if (reload) {
				this.$emit('reload');
			}
			this.$emit('update:open', false);
		},
		dialogBeforeClose,
	},
});
</script>

<style lang="scss"></style>
